import ready, {HTML, updateSortValue, handleSortChange} from './utils';
import initAccordion from './components/accordion';
import initOpenClose from './components/openClose';
import initAutocomplete from './components/autocomplete';
import {initListFilter} from './utils/filters';
import {initSortSelector} from "./components/sortSelector";
import initDownloadContact from "./components/downloadContact";

declare global {
  interface Window {
    $: typeof jQuery;
  }
}
window.$ = jQuery;

ready(() => {
  HTML.classList.add('is-loaded');
  initDownloadContact();
  initAccordion();
  initOpenClose();
  initAutocomplete();
  initSortSelector();
  initListFilter();
});
